import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotRecommendSection() {
  const featuredComics = getFeaturedComics();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最受欢迎的蜜桃少年漫画精选</p>
        </div>
        <Link
          to="/category/rexie"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
        {featuredComics.map((comic) => (
          <ComicCard
            key={comic.id}
            id={comic.id}
            title={comic.title}
            author={comic.author}
            cover={comic.cover}
            rating={comic.rating}
            views={comic.views}
            chapters={comic.chapters}
            status={comic.status}
            category={comic.category}
            tags={comic.tags}
          />
        ))}
      </div>
    </section>
  );
}